import { useEffect } from 'react';
import { useLocation } from './useLocation';
/**
 * Компонент для редиректа на другую страницу внутри разметки
 * Для перехода на другую страницу в коде лучше использовать useLocation
 */
export const Redirect = ({ href, to }) => {
    const [, push] = useLocation();
    useEffect(() => {
        push(href || to || '');
    }, [href, to, push]);
    if (typeof window === 'undefined') {
        push(href || to || '');
    }
    return null;
};
